export default __webpack_public_path__ + "static/media/Splaylion.dfaf5528.png";